module.exports = __webpack_public_path__ + "Sample-Remove-User.xlsx";